export default __webpack_public_path__ + "static/Blind-angels-tony-profile_mobile-feb7dd73e4802e7aa64c09869ff601a2.png";